import {
  GET_SLIDE_PRESET_CATEGORIES,
  GET_SLIDE_PRESETS,
  RESET_SLIDE_PRESETS,
  SEARCH_SLIDE_PRESETS,
} from "../_actions/types";

const initialState = {
  presetCategories: [],
  presets: [],
  loaded: false,
  page: 1,
  hasMore: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESET_SLIDE_PRESETS:
      return {
        ...state,
        presets: [],
        loaded: false,
        page: 1,
        hasMore: false,
      };
    case GET_SLIDE_PRESET_CATEGORIES:
      return {
        ...state,
        presetCategories: action.payload,
      };
    case GET_SLIDE_PRESETS:
      let presetPreload =
        state.page === 1
          ? action.payload
          : state.presets.concat(action.payload);
      return {
        ...state,
        loaded: true,
        presets: presetPreload,
        hasMore: action.hasMore,
        page: presetPreload.length > 0 ? state.page + 1 : 1,
      };
    case SEARCH_SLIDE_PRESETS:
      return {
        ...state,
        loaded: true,
        presets: action.payload,
        hasMore: false,
        page: 1,
      };
    default:
      return state;
  }
}
